import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import cn from "classnames";
import requests from "../../axios/requests";
import moment from "moment";

import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';

import { Pagination, Table } from "antd";
import ReuseDropDown from "../../components/reuseComponents/ReuseDropDown";
import InputWsButton from "../../components/reuseComponents/InputButton";
import variableLanguage from "../../utils/hooks/hookGetVariablesLanguage";
import MobileSidebar from "../../components/SideBar/MobileSidebar/MobileSidebar";
import Trial from "../../components/reuseComponents/Trial";
import { Line } from 'react-chartjs-2';

// SVG-компоненты с currentColor для поддержки светлой темы
const StatisticUpIcon = ({ className, ...props }) => (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M1.78033 11.0303C1.48744 11.3232 1.01256 11.3232 0.71967 11.0303C0.426777 10.7374 0.426777 10.2626 0.71967 9.96967L4.46967 6.21967C4.76256 5.92678 5.23744 5.92678 5.53033 6.21967L9.28033 9.96967C9.57322 10.2626 9.57322 10.7374 9.28033 11.0303C8.98744 11.3232 8.51256 11.3232 8.21967 11.0303L5 7.81066L1.78033 11.0303ZM1.78033 5.78033C1.48744 6.07322 1.01256 6.07322 0.71967 5.78033C0.426777 5.48744 0.426777 5.01256 0.71967 4.71967L4.46967 0.96967C4.76256 0.676777 5.23744 0.676777 5.53033 0.96967L9.28033 4.71967C9.57322 5.01256 9.57322 5.48744 9.28033 5.78033C8.98744 6.07322 8.51256 6.07322 8.21967 5.78033L5 2.56066L1.78033 5.78033Z" fill="currentColor"/>
    </svg>
);

const StatisticDownIcon = ({ className, ...props }) => (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d="M1.78033 0.96967C1.48744 0.676777 1.01256 0.676777 0.71967 0.96967C0.426777 1.26256 0.426777 1.73744 0.71967 2.03033L4.46967 5.78033C4.76256 6.07322 5.23744 6.07322 5.53033 5.78033L9.28033 2.03033C9.57322 1.73744 9.57322 1.26256 9.28033 0.96967C8.98744 0.676777 8.51256 0.676777 8.21967 0.96967L5 4.18934L1.78033 0.96967ZM1.78033 6.21967C1.48744 5.92678 1.01256 5.92678 0.71967 6.21967C0.426777 6.51256 0.426777 6.98744 0.71967 7.28033L4.46967 11.0303C4.76256 11.3232 5.23744 11.3232 5.53033 11.0303L9.28033 7.28033C9.57322 6.98744 9.57322 6.51256 9.28033 6.21967C8.98744 5.92678 8.51256 5.92678 8.21967 6.21967L5 9.43934L1.78033 6.21967Z" fill="currentColor"/>
    </svg>
);

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const COLOR_POSITIVE_DARK = '#30E0A1';
const COLOR_NEGATIVE_DARK = '#FF3434';
const COLOR_POSITIVE_LIGHT = '#059669';
const COLOR_NEGATIVE_LIGHT = '#DC2626';

const ChartJs = (props) => {
    let { data, diff = 0, isLightTheme = false } = props;
    const colorPositive = isLightTheme ? COLOR_POSITIVE_LIGHT : COLOR_POSITIVE_DARK;
    const colorNegative = isLightTheme ? COLOR_NEGATIVE_LIGHT : COLOR_NEGATIVE_DARK;
    const lineColor = Math.sign(diff) === -1 ? colorNegative : colorPositive;

    let options = {
        responsive: true,
        animation: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                displayColors: false,
                titleAlign: 'center',
                bodyAlign: 'center',
                bodyColor: lineColor,
                callbacks: {
                    label: function (tooltipItem) {
                        return tooltipItem.formattedValue;
                    },
                    labelColor: function () {
                        return { backgroundColor: lineColor };
                    },
                },
                borderColor: lineColor,
            },
        },
        elements: {
            line: {
                tension: 0.4
            }
        },
        scales: {
            y: { display: false },
            x: { display: false }
        },
        title: {
            display: false
        },
    };

    let labels = data?.data?.length > 0 && data?.data.map((elem) => elem.date);
    let dataChart = {
        labels,
        datasets: [
            {
                label: '123',
                data: data?.data?.length > 0 && data?.data.map((elem) => elem.amount),
                borderColor: lineColor,
                backgroundColor: 'transparent',
            }
        ]
    };
    return (
        <div>
            <Line options={options} data={dataChart}/>
        </div>
    );
};

const HistoryPay = () => {
    const { trial_end_date, trial_status, activeTheme } = useSelector(state => state.Reducer);
    const isLightTheme = activeTheme === true;

    const variable_1 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_1"});
    const variable_4 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_4"});
    const variable_5 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_5"});
    const variable_6 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_6"});
    const variable_7 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_7"});
    const variable_8 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_8"});
    const variable_10 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_10"});
    const variable_11 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_11"});
    const variable_12 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_12"});
    const variable_13 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_13"});
    const variable_14 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_14"});
    const variable_17 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_17"});
    const variable_18 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_18"});
    const variable_19 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_19"});
    const variable_20 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_20"});
    const variable_21 = variableLanguage({keyPage: "historyPay", keyVariable: "variable_21"});

    const [data, setData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(1);
    const [innerHeight, setInnerHeight] = useState(0);
    const [innerWidth, setInnerWidth] = useState(0);
    const [progressData, setProgressData] = useState([]);

    const [activePeriod, setActivePeriod] = useState(0);
    const [activeSort, setActiveSort] = useState(0);
    const [searchCourses, setSearchCourses] = useState('');
    const [flagOpenStatisticTiming, setFlagOpenStatisticTiming] = useState(false);
    const [flagOpenStatisticCourse, setFlagOpenStatisticCourse] = useState(false);
    const [flagHiddenFotter, setFlagHiddenFooter] = useState(null);

    const columns = [
        {
            title: variable_17,
            dataIndex: 'quest_member_fio',
        },
        {
            title: variable_18,
            dataIndex: 'created_at',
            render: (record) => moment(record).format('DD.MM.YY HH:mm')
        },
        {
            title: variable_19,
            render: (record) => record.quest.name || ''
        },
        {
            title: variable_20,
            dataIndex: 'amount',
            render: (record) => record / 100
        },
        {
            title: variable_21,
            dataIndex: 'marketplace_fee',
            render: (record) => record / 100
        }
    ];
    const periodList = [variable_1, variable_4, variable_5, variable_6];
    const periodListValue = ["all", 'week', 'month', 'year'];

    const sortList = [variable_8, variable_10, variable_11, variable_12, variable_13]
    const sortListValue = ['created_at', 'quest_name', 'user__profile__name', 'amount', 'fee']

    let itemRender = (_, type, originalElement) => {
        if (type === "prev")
            return null;
        if (type === "next") {
            return;
        }
        return originalElement;
    };
    let removeVariablesInExcel = (arr) => {
        let result = [];
        if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
                let newObj = {
                    "Фио пользователя": arr[i].quest_member_fio,
                    "Дата и время операции": arr[i].created_at,
                    "Наименование курса": arr[i].quest.name,
                    "Сумма операции (руб.)": arr[i].amount / 100,
                    "Комиссия МП (руб.)": arr[i].marketplace_fee / 100
                }
                result = [...result, newObj];
            }
        }
        return result;
    }
    let exportToCSV = (csvData, fileName) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const newData = removeVariablesInExcel(csvData);
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: fileType});
        FileSaver.saveAs(data, fileName + fileExtension);
    };
    let handleResize = () => {
        setInnerHeight(window.innerHeight - 365)
        setInnerWidth(window.innerWidth - 30)
    }
    let apiGetHistory = (activePeriodProps = activePeriod, activeSortProps = activeSort, courseName = searchCourses) => {
        requests.organization.get_payment_history(
            periodListValue[activePeriod], sortListValue[activeSort],
            courseName, currentPage, 12
        )
            .then(res => {
                setData(res.data.results);
                setTotal(res.data.count);
            })
            .catch(err => console.error(err))
    }
    let apiGetPaymentProgress = () => {
        requests.organization.get_payment_progress(periodListValue[activePeriod])
            .then(res => setProgressData(res.data))
            .catch(err => console.error(err))
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])
    useEffect(() => {
        apiGetHistory();
        apiGetPaymentProgress();
    }, [activePeriod, activeSort, searchCourses])
    const isPositive = Math.sign(progressData?.diff) !== -1;
    return (
        <div className={cn("history_pay", { "theme-white": isLightTheme })}>
            <div className="inner_block">
                {(trial_status === 0 || trial_status === 1) && <Trial/>}
                <div className="h1"><span>История платежей</span></div>
                <div className="top_sort">
                    <ReuseDropDown
                        flagOpen={flagOpenStatisticTiming}
                        setFlagOpen={(bool) => setFlagOpenStatisticTiming(bool)}
                        arrList={periodList}
                        activeArrList={activePeriod}
                        setActiveArrList={(indx) => setActivePeriod(indx)}
                        onBlur={() => setFlagOpenStatisticTiming(false)}
                    />
                    <ReuseDropDown
                        flagOpen={flagOpenStatisticCourse}
                        setFlagOpen={(bool) => setFlagOpenStatisticCourse(bool)}
                        arrList={sortList}
                        activeArrList={activeSort}
                        setActiveArrList={(indx) => setActiveSort(indx)}
                        onBlur={() => setFlagOpenStatisticCourse(false)}
                    />
                    <div className="search">
                        <InputWsButton
                            value={searchCourses}
                            setValue={(e) => setSearchCourses(e)}
                            placeholder={variable_7}
                        />
                    </div>
                </div>
                <div className="statistic_row">
                    <div className="item">
                        <div className="title">Оплата курсов</div>
                        <div className="chart">
                            <ChartJs data={progressData} isLightTheme={isLightTheme}/>
                        </div>
                        <div className="info">
                            <div className={cn("left", { "stat-up": isPositive, "stat-down": !isPositive })}>
                                {isPositive ? <StatisticUpIcon /> : <StatisticDownIcon />}
                                <span>{progressData?.diff}%</span>
                            </div>
                            <div className="right">
                                {progressData?.count}
                            </div>
                        </div>
                        <span>{periodList[activePeriod]}</span>
                    </div>
                </div>
                <div className="table_block">
                    <div
                        className="export_btn"
                        onClick={(e) => exportToCSV(data, 'test_file_name')}
                    >
                        Скачать файл Excel
                    </div>
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey={'id'}
                        total={12}
                        pagination={false}
                        scroll={{x: window.innerWidth < 1380 ? innerWidth : 0, y: innerHeight}}
                        locale={{emptyText: variable_14}}
                    />
                    {total && total > 12
                        ? <div className="pagination_all">
                            <Pagination
                                itemRender={itemRender}
                                defaultCurrent={1}
                                defaultPageSize={12}
                                total={total}
                                onChange={(e) => setCurrentPage(e)}
                                showTitle={false}
                            />
                        </div>
                        : <></>
                    }
                </div>
            </div>
        </div>
    );
};

export default HistoryPay;